import { getObjectKeysAsObject } from "@checkout/helpers";
import type { PriceChangeContext } from "./types";

const didPriceChange = (context: PriceChangeContext, _event: unknown) => {
  return (
    context.cartQuote.priceChange?.hasDifference === true &&
    context.cartQuote.priceChange?.acknowledged === false
  );
};

export const guards = {
  didPriceChange,
};

export const GuardTypes = getObjectKeysAsObject(guards);
